module.exports = __webpack_public_path__ + "img/upper-egypt.4116afd5.webp";